import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeTokens } from '../actions';
import TokensActions from '../containers/TokensActions';
import TokensPanel from '../components/TokensPanel';

export default (name, urls, access) => ({
  ...tabTemplate(name, TokensPanel, matchSingleUrl(urls), TokensActions),
  ...tabCloser('closeTokensTab', closeTokens),
  ...tabIcons('code'),
  access,
  componentState: ({ url }) => categoryTab(url, 'all'),
  order: 900,
  position: 'top-right',
});
